import { takeEvery, put } from "redux-saga/effects";
import { request } from "../../../api/Service";
import { getErrorMessage } from "../../../components/utils/errorHandler";
import { toast } from "react-toastify";
export default function* watcherUpdateSupplierSaga() {
  yield takeEvery("UPDATE_SUPPLIER", workerSaga);
}

function* workerSaga(action) {
  try {
    yield put({ type: "DISPLAY_LOADER" });
    let payload = {};
    yield request("patch", action.payload, "/update-supplier").then(
      (response) => {
        payload = response;
      }
    );
    toast.success(payload);
    var formatUrl = "/get-suppliers";
    yield request("get", action.payload, formatUrl).then((response) => {
      payload = response;
    });
    yield put({ type: "SUPPLIERS_LIST", payload: payload });

    yield put({ type: "DISPLAY_LOADER" });
  } catch (e) {
    yield put({ type: "LOADING_BUTTON_SPINNER" });
    console.log(e.response);
    console.log("update-supplier-saga", e);
    console.log("update-supplier-saga", e.response);
    const errorMessage = getErrorMessage(e.response);
    toast.error(errorMessage);
    yield put({ type: "DISPLAY_LOADER" });
    yield put({ type: "API_ERRORED", payload: e });
  }
}
